import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SeverityType, SeverityViewService } from '../services/severity-view.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LoadingService } from '../services/loading.service';
import { finalize } from 'rxjs/operators';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-details-table',
    templateUrl: './details-table.component.html',
    styleUrls: ['./details-table.component.css'],
    imports: [CdkScrollable, MatDialogContent, MatTable, MatSort, NgFor, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, NgIf, MatDialogActions, MatButton]
})
export class DetailsTable {
  
  detailsDataSource: SeverityType[] = [];
  displayedColumns:string[] = []; // List of column descriptions from database
  displayedColumnValues:string[] = []; // List of data Columns to display

  resultid :string;
  site: string;
  
  imageSrc!: SafeUrl;
  imageSrc2!: SafeUrl;
  
  constructor(public dialogRef: MatDialogRef<DetailsTable>,
    @Inject(MAT_DIALOG_DATA) public detailsData: DetailsDialogData,
    private service: SeverityViewService,
    private sanitizer : DomSanitizer,
    private loadingService: LoadingService
  )

  { 
    console.info(detailsData)
  
    this.detailsDataSource.push(detailsData.details);

    this.resultid = detailsData.details.ResultId;
    this.site = detailsData.details.site;

    console.log(this.detailsDataSource)

    Object.keys(this.detailsDataSource[0]).filter(k => (k.startsWith("Custom") || k.startsWith("Variable")) && k.endsWith("Name")).forEach(
      (field:string) => {
          if (this.detailsDataSource[0][field as keyof SeverityType] != null) {
            this.displayedColumns.push(this.detailsDataSource[0][field as keyof SeverityType] as string);
            this.displayedColumnValues.push(field.replace('Name',''))
          }
        }
    );
 
    if (detailsData.details.Image1 != undefined){
      let firstimage: number = detailsData.details.Image1 as unknown as number;
      if (firstimage) {
        this.getimage('Image1');
      }
    }
    if (detailsData.details.Image2 != undefined){
      let secondimage: number = detailsData.details.Image2 as unknown as number;
      if (secondimage) {
        this.getimage('Image2');
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  close(): void {
    this.dialogRef.close();
  }
  getimage(image:string){
    let base64data: any;
    let pic!:Blob;
    this.loadingService.show(); 

    this.service.getpic(this.resultid,image,this.site).pipe(finalize(() => this.loadingService.hide())).subscribe(
      
      (blob) => {
        console.debug("Received picture")
        pic = blob; // Save the blob to be accessed later

        var reader = new FileReader();
        reader.readAsDataURL(blob); 
        reader.onloadend = (out) => {
          console.log(' In the function ')
          base64data = reader.result;
          if (image === 'Image1') {
            this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(base64data);
          }

          if (image === 'Image2') {
            this.imageSrc2 = this.sanitizer.bypassSecurityTrustUrl(base64data);
          }
        }          
      },
      (err) => {
        console.error("Error generating picture", err);

      }
      );
  }

}

export interface DetailsDialogData {
  details: SeverityType;
}
